import { forwardRef } from "react";

import { Input } from "@newsela/angelou";
import PropTypes from "prop-types";
import {
  withTrackEvent,
  objectTypes,
  actionPrefixes,
  actionNames,
} from "@newsela/snitch";

import {
  errorTextHeight,
  responsePlaceholderCss,
  responseWrapperCss,
  withTrackEventCss,
} from "./ResponseInput.style";

const propTypes = {
  error: PropTypes.string,
  index: PropTypes.number,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  touched: PropTypes.bool,
  value: PropTypes.string,
};

const InputWithTrackEvent = withTrackEvent(Input);
const eventProperties = {
  actionName: actionNames.add,
  actionPrefix: actionPrefixes.initiate,
  objectType: objectTypes.poll,
  streamProperties: {
    description: "Adds poll response option",
  },
};

export const ResponseInput = forwardRef(
  ({ error, index, onBlur, onChange, touched, value }, ref) => {
    const indexIfNoValue = value !== "" ? value : `#${index}`;
    return (
      <div css={responseWrapperCss}>
        <div css={withTrackEventCss}>
          <InputWithTrackEvent
            dataProps={{
              "data-qa-selector": `response-option-${indexIfNoValue}`,
            }}
            error={error}
            id={value}
            inputType={Input.inputTypes.text}
            label={`Option ${index + 1}`}
            onBlur={onBlur}
            onChange={onChange}
            placeholder="Response option"
            ref={ref}
            touched={touched}
            underInputId={`response-option-${indexIfNoValue}`}
            value={value}
            __cssFor={{
              root: errorTextHeight,
              input: [responsePlaceholderCss],
            }}
            {...eventProperties}
          />
        </div>
      </div>
    );
  },
);

ResponseInput.propTypes = propTypes;
ResponseInput.displayName = "ResponseInput";
export default ResponseInput;
